// TODO: create models for traveller categories
import { Injectable } from '@angular/core';
import { Action } from 'redux';
import { ProductCategory } from '@ridango/core';




export interface TravellerAction extends Action {

    type: string;

    payload?: any;
}



@Injectable()
export class TravellerActions {
    static FETCH_START = '[Traveller]: Fetch start';
    static FETCH_SUCCESS = '[Traveller]: Fetch success';
    static FETCH_FAILED = '[Traveller]: Fetch failed';
    static FETCH_END = '[Traveller]: Fetch end';
    static SET_TRAVELLER_CATEGORIES = '[Traveller]: Set traveller categories';
    static SET_ALL_TRAVELLER_CATEGORIES = '[Traveller]: Set ALL traveller categories';
    static SET_TRAVELLER_CATEGORY = '[Traveller]: Set selected traveller category id';
    static SET_TRAVELLER_CATEGORY_OBJ = '[Traveller]: Set selected traveller category object';
    static CLEAR_TRAVELLER = '[Traveller] Clear traveller';

    categoriesFetchStart (): TravellerAction {
        return {
            type: TravellerActions.FETCH_START
        };
    }

    categoriesFetchSuccess ( payload: any ): TravellerAction {
        return {
            type: TravellerActions.FETCH_SUCCESS,
            payload: payload
        };
    }



    categoriesFetchFailed ( payload: any ): TravellerAction {
        return {
            type: TravellerActions.FETCH_FAILED,
            payload: payload
        };
    }



    categoriesFetchEnd (): TravellerAction {
        return {
            type: TravellerActions.FETCH_END
        };
    }


    // this is 'older' version. uses custom data format
    setTravellerCategories ( payload: any ): TravellerAction {
        return {
            type: TravellerActions.SET_TRAVELLER_CATEGORIES,
            payload: payload
        };
    }


    setAllTravellerCategories ( payload: ProductCategory[] ) {
        return {
            type: TravellerActions.SET_ALL_TRAVELLER_CATEGORIES,
            payload: payload
        };
    }

    setSelectedCategory ( payload: any ): TravellerAction {
        return {
            type: TravellerActions.SET_TRAVELLER_CATEGORY,
            payload: payload
        };
    }
    setSelectedCategoryObj ( payload: ProductCategory ): TravellerAction {
        return {
            type: TravellerActions.SET_TRAVELLER_CATEGORY_OBJ,
            payload: payload
        };
    }

    clearTraveller (): TravellerAction {
        return {
            type: TravellerActions.CLEAR_TRAVELLER
        };
    }

}
